import { emitWhenConnected } from './socketHelpers';

const ADMIN_ACK_TIMEOUT_MS = 30000;

export function emitAck(socket, event, data = {}) {
  return new Promise((resolve, reject) => {
    if (!socket) {
      reject(new Error('Нет соединения с админ-сервером'));
      return;
    }

    const timer = setTimeout(() => {
      reject(
        new Error(
          'Таймаут ответа админки. Проверьте вход под учёткой admin и перезагрузите страницу.'
        )
      );
    }, ADMIN_ACK_TIMEOUT_MS);

    const finish = (fn) => (arg) => {
      clearTimeout(timer);
      fn(arg);
    };

    emitWhenConnected(socket, () => {
      socket.emit(event, data, (response) => {
        if (response?.status === 'ok') {
          finish(resolve)(response);
        } else {
          finish(reject)(new Error(response?.message || 'Ошибка запроса'));
        }
      });
    });
  });
}
